import type NativeArray from '@ember/array/-private/native-array';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type AbilitiesService from 'ember-can/services/abilities';
import type SkinnyLocationModel from 'garaje/models/skinny-location';
import type SkinnyLocationsService from 'garaje/services/skinny-locations';
import throwUnlessTaskDidCancel from 'garaje/utils/throw-unless-task-did-cancel';

export default class LocationOverviewRoute extends Route {
  @service declare abilities: AbilitiesService;
  @service('skinny-locations') declare skinnyLocationsService: SkinnyLocationsService;

  async model(): Promise<void | NativeArray<SkinnyLocationModel> | undefined> {
    return this.skinnyLocationsService.loadAllTask.perform().catch(throwUnlessTaskDidCancel);
  }
}
